{
  "version": 1,
  "asset_id": "0a3cd1e0-f506-4110-bab4-30523bd334c3",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0a3cd1e0-f506-4110-bab4-30523bd334c3/carage-semrush-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0a3cd1e0-f506-4110-bab4-30523bd334c3/carage-semrush-640.webp",
  "original_filename": "carage-semrush-640.webp",
  "size": 15144,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:28Z"
}
